import { render, staticRenderFns } from "./SwitchBranch.vue?vue&type=template&id=7f623a27&"
import script from "./SwitchBranch.vue?vue&type=script&lang=js&"
export * from "./SwitchBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports